/**
 * 区间取随机值
 * @param {Number} min 最小值
 * @param {Number} max 最大值
 */
export default function random(min, max) {
  if (min >= 0 && max >= 0 && max >= min) {
    let gap = max - min + 1
    return Math.floor(Math.random() * gap + min)
  } else {
    return 0
  }
}



// WEBPACK FOOTER //
// ./packages/utils/random.js